import { useEffect, useState } from "react";

export const useDebouncedStrandLossFilter = <T>(
  value: T,
  delayMs: number,
): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebouncedValue(value), delayMs);
    return () => clearTimeout(timeout);
  }, [value, delayMs]);

  return debouncedValue;
};
